export default [
    // Note: this is not an empty page as data analytic settings are on it.
    // {
    //     path: '/admin/curriculum/',
    //     component: Empty,
    //     alias: '/WebModules/CurriculumAdministration/CurriculumAdministrationWorkDesk.aspx',
    //     meta: {menu_id: 'CURRICULUMADMIN'},
    // },
];
